import React from 'react';

export const PhoneInputScreen = ({ phoneNumber, onChange, onSubmit, error, isLoading, businessLogo }) => {
  return (
    <div className="min-h-screen bg-white relative flex items-center justify-center">
      <div className="max-w-md mx-auto w-full px-4">
        <div className="bg-gradient-to-br from-rose-50 via-pink-50 to-purple-50 backdrop-blur-sm border border-white/20 rounded-3xl p-8 shadow-2xl">
          <div className="text-center mb-8">
            <h1 className="text-2xl font-bold text-gray-900 mb-2">ברוכים הבאים</h1>
            <p className="text-gray-600">יש להזין מספר פלאפון לקוח כדי להמשיך</p>
          </div>

          <div className="space-y-4">
            <div>
              <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                מספר פלאפון
              </label>
              <input
                id="phone"
                type="tel"
                value={phoneNumber}
                onChange={onChange}
                placeholder="יש להזין מספר פלאפון לקוח"
                className={`w-full px-4 py-3 bg-white/60 backdrop-blur-sm border rounded-2xl focus:outline-none focus:ring-2 focus:ring-rose-500 focus:border-transparent transition-all duration-300 ${
                  error ? 'border-red-300 ring-2 ring-red-200' : 'border-white/30'
                }`}
              />
              {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
            </div>

            <button
              onClick={onSubmit}
              disabled={isLoading}
              className="w-full bg-gradient-to-r from-rose-500 to-pink-500 text-white py-3 rounded-2xl font-semibold hover:shadow-lg transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading ? 'בודק לקוח...' : 'המשך'}
            </button>
          </div>
        </div>

        {/* Business Logo - Below the card */}
        {businessLogo && (
          <div className="w-full py-6 flex justify-center">
            <img
              src={businessLogo}
              alt="Business Logo"
              className="h-16 w-auto object-contain"
            />
          </div>
        )}
      </div>
    </div>
  );
};
